import type { FC, SVGProps } from 'react';

export const SortInactiveIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="22"
      fill="none"
      viewBox="0 0 22 22"
      height="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.4685 12.9382H6.53146C6.2934 12.9382 6.16047 13.1896 6.3079 13.3612L10.2764 17.963C10.39 18.0947 10.6088 18.0947 10.7236 17.963L14.6921 13.3612C14.8395 13.1896 14.7066 12.9382 14.4685 12.9382Z"
      />
      <path
        fill="currentColor"
        d="M14.6921 9.63879L10.7236 5.03703C10.61 4.90531 10.3912 4.90531 10.2764 5.03703L6.3079 9.63879C6.16047 9.81039 6.2934 10.0617 6.53146 10.0617H14.4685C14.7066 10.0617 14.8395 9.81039 14.6921 9.63879Z"
      />
    </svg>
  );
};
